import React from "react"
import { Content } from "AtomicComponents"

const WysiwygContent = props => <Content {...props} />

WysiwygContent.displayName = "WysiwygContent"

export default WysiwygContent




// WEBPACK FOOTER //
// ./src/blocks/WysiwygContent/index.js